@if (data['selector'] == undefined && showForm) {
  <dhs-form [action]="'MODIFY'" [fieldGroup]="_currentData._currentFormFields" [config]="config" [formtype]="'popup'"
    [customButton]='btn' [data]="_currentData._currentData"
    (saveFinished)="onSaveFinished($event)" (cancel)="closePopUp()">
  </dhs-form>
}